import type { OrigenProveedor, Producto } from '@/types';

/** ID público en URL/API: "123", "tvc-1523", "syscom-987" */
export function productCatalogId(p: Producto): string {
  if (p.catalog_id) return p.catalog_id;
  if (p.origen && p.origen !== 'alarcom' && p.id_externo) {
    return `${p.origen}-${p.id_externo}`;
  }
  if (p.id_pto != null) return String(p.id_pto);
  return '';
}

export function productPath(p: Producto): string {
  return `/producto/${productCatalogId(p)}`;
}

export function productCartMeta(p: Producto): {
  origen: OrigenProveedor;
  idExterno: string | null;
  skuExterno: string | null;
  refId: number;
} {
  const origen = (p.origen ?? 'alarcom') as OrigenProveedor;
  return {
    origen,
    idExterno: p.id_externo ?? null,
    skuExterno: p.sku_externo ?? null,
    refId: p.id_pto ?? 0,
  };
}
